<template>
  <v-navigation-drawer app permanent :mini-variant="collapsed" :expand-on-hover="expandOnHover" v-if="isInitialized && isAdministrator">
    <v-list dense nav>
      <v-list-item two-line class="px-0">
        <v-list-item-avatar color="transparent">
          <img src="../../assets/tr-logo.png" alt="Argo Time Report">
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title color="primary">{{ clientName }}</v-list-item-title>
          <v-list-item-subtitle color="secondary">Versione {{ clientVersion }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mb-4"></v-divider>
      <v-list-item color="primary" v-for="nav in navs" :key="nav.title" :to="nav.link">
        <v-list-item-icon>
          <v-icon color="grey" v-if="$route.path !== nav.link">{{ nav.icon }}</v-icon>
          <v-icon v-else>{{ nav.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ nav.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

const allNavs = [
  { title: 'Dashboard', icon: 'mdi-view-dashboard', link: '/search' },
  { title: 'Il mio tempo', icon: 'mdi-calendar-clock', link: '/calendar' },
  { title: 'Impostazioni', icon: 'mdi-cog', link: '/settings' }
];

export default {
  name: 'RgNavigation',
  props: [ 'collapsed' ],

  data: ()=> ({
    expandOnHover: false, // flag che espande il menu all'hover del mouse.
    clientName: process.env.VUE_APP_CLIENT_NAME, // nome del client.
    clientVersion: process.env.VUE_APP_CLIENT_VERSION, // versione del client. 
  }),

  computed: {
    ...mapGetters('argoStore', [ 'isInitialized', 'isAdministrator' ]),

    navs(){
      return (this.isAdministrator) ? [ ...allNavs ] : [ ];
    }
  }
}
</script>